export const MdSelectors = {
    RefController: (state) => state.MarketData.reference,
    IsRefDataInView: (state) => state.MarketData.reference.isInView,
    IsRefDataFetching: (state) => state.MarketData.reference.isFetching,
    RefData: (state) => state.MarketData.reference.data,
    ExRates: (state) => state.MarketData.exRates || {},
};
